export function toCamelCase(inputString) {
  // Split the input string into words using space as a separator
  const words = inputString?.split(" ");

  // Convert the first word to lowercase and keep the rest as is
  const camelCaseWords = [words[0].toLowerCase(), ...words.slice(1)];

  // Join the words back together without spaces
  const camelCaseString = camelCaseWords.join("");

  return camelCaseString;
}

export function sleep(delay = 0) {
  return new Promise((resolve) => {
    setTimeout(resolve, delay);
  });
}

export function extractIdFromIngredientString(ingredientString) {
  const parts = ingredientString?.split(" --- ");
  if (parts?.length === 2) {
    return parts[1];
  } else {
    // If the format is not as expected, return null or handle the error as needed
    return null;
  }
}

export function extractIngredientName(ingredientString) {
  const parts = ingredientString?.split(" --- ");
  if (parts?.length === 2) {
    return parts[0];
  } else {
    // If the format is not as expected, return null or handle the error as needed
    return "";
  }
}

export function getEfficacyImages(technofuctionality) {
  switch (technofuctionality.toLowerCase()) {
    case "Agent emulsifiant".toLowerCase():
    case "Agent emulsifiant/Stabilisateur d'emulsion".toLowerCase():
    case "Stabilisateur d'emulsion".toLowerCase():
      return [
        "/assets/images/efficacies_help/emulsifants/emulsifant.png",
        "/assets/images/efficacies_help/emulsifants/emulsifant2.png",
      ];
    case "Agent moussant".toLowerCase():
    case "Agent moussant/Stabilisateur de mousse".toLowerCase():
    case "Stabilisateur de mousse".toLowerCase():
      return ["/assets/images/efficacies_help/moussant/moussant.png"];
    case "Antimicrobien".toLowerCase():
      return [
        "/assets/images/efficacies_help/antimicrobiens/antimicrobiens.png",
      ];
    case "Antioxidant".toLowerCase():
      return ["/assets/images/efficacies_help/antioxidants/antioxidants.png"];
    case "Substitut de sucre".toLowerCase():
      return [
        "/assets/images/efficacies_help/sucre/sucre.png",
        "/assets/images/efficacies_help/sucre/sucre2.png",
        "/assets/images/efficacies_help/sucre/sucre3.png",
      ];
    case "Substitut de matiere grasse".toLowerCase():
    case "Substitut de matière grasse".toLowerCase():
    case "Substitut de matiere grasse (Gras sature, Trans gras)".toLowerCase():
    case "Substitut de matiere grasse (Reduire le gras)".toLowerCase():
    case "Substitut de matiere grasse (Trans gras)".toLowerCase():
      return [
        "/assets/images/efficacies_help/grasse/grasse.png",
        "/assets/images/efficacies_help/grasse/grasse2.png",
      ];
    case "Agent gelifiant".toLowerCase():
    case "Agent gelifiant/Epaississant".toLowerCase():
    case "Agent epaississant".toLowerCase():
      return ["/assets/images/efficacies_help/geli/geli.png"];
    default:
      return [];
  }
}
